import React from 'react'
import "./Rightpart.css";
import profile from "../assets/images/profile.png";
import ordersdetail from "../assets/images/order-detail.png";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function OrderdetailRight() {
  return (
    <div className='order-detail-main-outer'>
      <div className='order-detail-content'>
         <div className='dashbord-header'>
            <p className='title-dash'>Order Detail</p>
          <div className="dropdown-section d-flex align-items-center">
            <div className="dropdown">
              <button
                className="btn dropdown-toggle d-flex align-items-center gap-3"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-name">
                  <img src={profile} alt="" />
                  <div className="name-mail">
                    <h4>DEEPAK SHARMA</h4>
                    <p>Deepak@gmail.com</p>
                  </div>
                </div>
                <ExpandMoreIcon />
              </button>

              <ul className="dropdown-menu ">
                <li>
                  <a className="dropdown-item" href="#">
                    Profile
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Support
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
         </div>
         <div className='outer-box-oc'>
           <div className='row'>
              <div className='col-lg-7 col-12'>
                    <div className='sr-sec'>
                        <div className='box-top'>
                            <div className='sr-number'>
                                <h4>SR#45687978</h4>
                            </div>
                            <div className='sr-date'>
                                <p>Date-17-04-2026</p>
                            </div>
                        </div>
                        <div className='loxer-sr'>
                            <div className='content-prices'>
                                <div className='img-sr'>
                                   <img src={ordersdetail} alt="" />
                                </div>
                                <div className='text-sr-prices'>
                                    <div className='text-sr'>
                                        <h5>Nazakat Hand Woven Beige Cotton Cushion Cover</h5>
                                        <div className="product-info">
                                           <p>SKU: CU03970001_1.04x1.04</p>
                                           <p>Size : 46x46 cm</p>
                                        </div>
                                        <p className="qty">Qty : 1</p>
                                    </div>
                                    <div className='sr-prices'>
                                        <p>₹ 3,000.00</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div className='loxer-sr'>
                            <div className='content-prices'>
                                <div className='img-sr'>
                                   <img src={ordersdetail} alt="" />
                                </div>
                                <div className='text-sr-prices'>
                                    <div className='text-sr'>
                                        <h5>Nazakat Hand Woven Beige Cotton Cushion Cover</h5>
                                        <div className="product-info">
                                           <p>SKU: CU03970001_1.04x1.04</p>
                                           <p>Size : 46x46 cm</p>
                                        </div>
                                        <p className="qty">Qty : 1</p>
                                    </div>
                                    <div className='sr-prices'>
                                        <p>₹ 3,000.00</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='col-lg-5 col-12'>
                    <div className='cst-info'>
                        <div className='cst-header box-top'>
                            <h5>Customer Information</h5>
                        </div>
                        <div className='detail-cst'>
                            <div className='icon-info'>
                               <PersonOutlineOutlinedIcon />
                               <p>Deepak Sharma</p>
                            </div>
                             <div className='icon-info'>
                               <EmailOutlinedIcon />
                               <p>Deepak@gmail.com</p>
                            </div>
                             <div className='icon-info'>
                               <LocalPhoneOutlinedIcon />
                               <p> +91 9874563218</p>
                            </div>
                             <div className='icon-info'>
                               <FmdGoodOutlinedIcon />
                               <p>15 Corner, Sector 10 Shopping Center Vijay Path Crossing, Madhyam Marg, Mansarovar, Jaipur, Rajasthan 302020</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className='col-lg-7 col-12'>
                    <div className='payment-order'>
                         <div className='box-top'>
                            <div className='sr-number'>
                                <h4>Payment</h4>
                            </div>
                            <div className='sr-date pyment-invoice'>
                                <p>Download Invoice</p>
                            </div>
                        </div>
                        <div className='pymt-box'>
                            <div className='nme-price'>
                                <p className='pmt-box-text'>Subtaotal (2 Items)</p>
                                <p className='pmt-box-price'>₹ 6,000.00</p>
                            </div>
                            <div className='nme-price'>
                                <p className='pmt-box-text'>Tax</p>
                                <p className='pmt-box-price'>₹ 800.00</p>
                            </div>
                            <div className='nme-price'>
                                <p className='pmt-box-text'>Discount</p>
                                <p className='pmt-box-price'>₹ 0</p>
                            </div>
                            <div className='nme-price'>
                                <p className='pmt-box-text'>Shipping</p>
                                <p className='pmt-box-price'>Free Shipping</p>
                            </div>
                            <div className='nme-price total-price'>
                                <h5 className='total-t'>TOTAl</h5>
                                <p className='total-pricee'>₹ 6,800.00</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='col-lg-5 col-12'>
                    <div className='billing-add-box'>
                        <div className='box-top'>
                            <div className='sr-number'>
                                <h4>Billing address</h4>
                            </div>
                        </div>
                        <div className='billing-text'>
                            <p>Same as shipping address</p>
                        </div>
                    </div>
                </div>
 
                 {/* ------------------Manager-address----- */}
                




            </div>
         </div>
      </div>
    </div>
  )
}
